import type { ErrorCode } from './ErrorPage'

/** Simple bus-on-a-road drawing. The badge changes with the problem. Colours come from theme tokens. */
export function ErrorIllustration({ code }: { code: ErrorCode }) {
  const serverSide = code === 500 || code === 502 || code === 503 || code === 504
  return (
    <svg viewBox="0 0 320 220" role="img" aria-label="" className="h-auto w-full max-w-sm text-primary">
      {/* road */}
      <rect x="10" y="168" width="300" height="10" rx="5" className="fill-surface-sunken" />
      <g className="[stroke:rgb(var(--border-strong))]" strokeWidth="3" strokeLinecap="round" strokeDasharray="14 14">
        <line x1="24" y1="173" x2="296" y2="173" />
      </g>
      {/* bus */}
      <rect x="56" y="78" width="188" height="84" rx="16" fill="currentColor" opacity="0.14" />
      <rect x="56" y="78" width="188" height="84" rx="16" fill="none" stroke="currentColor" strokeWidth="3" />
      <g className="fill-surface stroke-current" strokeWidth="2.5">
        <rect x="72" y="94" width="40" height="30" rx="6" />
        <rect x="120" y="94" width="40" height="30" rx="6" />
        <rect x="168" y="94" width="40" height="30" rx="6" />
        <rect x="216" y="94" width="20" height="46" rx="5" />
      </g>
      <line x1="56" y1="140" x2="244" y2="140" stroke="currentColor" strokeWidth="2.5" opacity="0.5" />
      <g className="fill-surface stroke-current" strokeWidth="3">
        <circle cx="100" cy="164" r="14" />
        <circle cx="200" cy="164" r="14" />
      </g>
      <circle cx="100" cy="164" r="4" fill="currentColor" />
      <circle cx="200" cy="164" r="4" fill="currentColor" />
      {/* badge */}
      <g transform="translate(232 36)">
        <circle r="26" className="fill-warning-soft stroke-warning" strokeWidth="3" />
        {serverSide ? (
          <g className="stroke-warning" strokeWidth="4" strokeLinecap="round">
            <line x1="0" y1="-11" x2="0" y2="3" />
            <line x1="0" y1="12" x2="0" y2="12.5" />
          </g>
        ) : (
          <g className="stroke-warning" strokeWidth="4" strokeLinecap="round" fill="none">
            <path d="M-12 -2a17 17 0 0 1 24 0" />
            <path d="M-6 6a8 8 0 0 1 12 0" />
            <line x1="-14" y1="14" x2="14" y2="-14" />
          </g>
        )}
      </g>
    </svg>
  )
}
